import api from '@/utils/axios/api';

export default {
  async getData({ commit }) {
    const {
      data: {
        data: {
          categories, extras, eurpln,
        },
      },
    } = await api.get('/data/provide');

    commit('setCategories', categories);
    commit('setBonuses', extras);
    commit('setCurrencyConverter', Number(eurpln));
  },

  changeCategoryId({ commit }, payload) {
    const categoryId = payload;

    commit('setCategoryId', categoryId);
    commit('setSubcategories', categoryId);
  },

  changeSubcategoryId({ commit }, payload) {
    commit('setSubcategoryId', payload);
  },

  resetOrder({ commit, state }) {
    commit('orderIncrement', (state.id + 1));
    commit('clearOrder');
  },

  async sendOrder({ commit, state, rootState }, { contact, permits }) {
    const { data: { data } } = await api.post('/order/finish', {
      user_id: rootState.auth.user.id,
      contact: {
        ...contact,
      },
      agreements: {
        ...permits,
      },
      comment: state.comment,
      category_id: state.subcategory_id,
      currency: state.currency,
      lang: state.lang,
      price: state.orderPrice,
      tastes: state.tastes,
      extras: state.extras,
      files: state.files,
    });
    commit('saveOrder', data);
  },
};
